// src/icons/Chevron.tsx
import { jsx } from "@emotion/react/jsx-runtime";
function Chevron({
  strokeWidth = "1.5",
  strokeLinecap = "round",
  strokeLinejoin = "round"
}) {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: "100%",
      viewBox: "0 0 16 16",
      fill: "none",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.3335 5.33337L8.00016 10L12.6668 5.33337",
          stroke: "currentColor",
          strokeWidth,
          strokeLinecap,
          strokeLinejoin
        }
      )
    }
  );
}

export {
  Chevron
};
